import { render, staticRenderFns } from "./DistributionCenterDetail.vue?vue&type=template&id=02a7c59d&"
import script from "./DistributionCenterDetail.vue?vue&type=script&lang=js&"
export * from "./DistributionCenterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports